<template>
	<div class="index">
		<!-- banner图 -->
		<div class="newsCenterBanenr">
			<img src="../../assets/xiangning/djxx/djxx_banner.png">
		</div>
		<div class="djxxhome_wrap">

			<!-- 上方筛选标题 -->
			<div class="swiper mySwiper" v-if="getdata.class_id2 != ''">
				<div class="swiper-wrapper swiper_box" >
					<div class="swiper-slide_item" v-for="item in titleList" :key="item.id":class="seclectTitleId == item.class_id ?'select_title_item_select': ''" @click="changeIndex(item)">
						<div class="select_title_item_text">
							{{ item.title }}
							<img style="width: 24px;height: 13px; margin-left: 10px;" v-if="item.new==1" src="../../assets/xiangning/djxx/new.png" alt="">
						</div>
					</div>
				</div>
				<!-- 上方分页器 -->
				<!-- <div class="swiper-pagination"></div> -->
			</div>
			<!-- 视频列表 -->
			<div class="dataList">
				<!-- 遍历列表循环 -->
				<div class="dataList_item" v-for="item in dataList" @click="goDjxxDetail(item.id)">
					<div class="dataList_item_top_img">
						<img :src="item.sz_img" alt="">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}</div>
						<!-- 下方课程信息 -->
						<div class="dataList_item_bottom_botom">
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_1.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									共{{ item.count }}课
								</div>
							</div>
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_3.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									{{ item.hours }}课时
								</div>
							</div>
							<div class="dataList_item_bottom_botom_item">
								<div class="dataList_item_bottom_botom_item_icon">
									<img src="../../assets/xiangning/djxx/icon_2.png" alt="">
								</div>
								<div class="dataList_item_bottom_botom_item_content">
									{{ item.nums }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 下方分页器 -->
			<Page :total="total" :per_page="per_page" :pageSize="[10]" @handleCurrentChange="handleCurrentChange">
			</Page>
		</div>

	</div>
</template>
<script>
import Swiper from 'swiper';
import { shouye } from '@/axios';
import Page from '@/components/page.vue'
import { news } from '../../axios';
export default {
	name:'djxx',
	data() {
		return {
			// 总数据条数
			total: 0,
			// 当前页码
			per_page: 1,

			input: '',
			// 标题列表模拟数据
			titleList: [

			],
			// 内容列表
			dataList: [],
			// 当前选中的标题id
			seclectTitleId: '',
			seclectTitle: '',
			getdata: {
				user_id: this.$store.state.user.userinfo2.id,
				flag: this.$store.state.user.userinfo2.flag,
				one_id: '',
				keys: '',
				page: 1
			}
		}
	},
	components: { Page },
	methods: {
		//  搜索
		goSearchDjxx() {

			this.getDataList()
		},
		//   分页器页码发生变化
		handleCurrentChange(val) {
			let that = this
			that.getdata.page = val
			this.getDataList()
		},
		goHome() {
			this.$router.push({
				path: '/home'
			})
		},
		// 点击展开及收起切换状态
		changeHeight(val) {

			this.ChangeHeightNum = val

		},
		// 初始化轮播图
		swiper() {
			this.$nextTick(() => {
				// 初始化轮播图
				var swiper = new Swiper(".mySwiper", {
					slidesPerView: 5,
					// slidesPerColumnFill:'row',
					slidesPerView: 5,
					slidesPerColumn: 2,
					spaceBetween: 20,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
						//修改分页器样式
						bulletClass: 'swiper-pagination-bullet',
						//激活样式
						bulletActiveClass: 'my-bullet-active',

					},
				});
			})


		},
		// 点击标题切换内容
		changeIndex(data) {
			let that = this
			// 设置选中样式
			this.seclectTitleId = data.class_id
			this.seclectTitle = data.title
			
			// 发起请求获取课程列表
			that.getdata.one_id = data.class_id
			that.getDataList()

		},
		// 点击关键字
		getKeys(val) {
			this.getdata.keys = val
		},
		// 跳转至党建学习详情
		goDjxxDetail(id) {

			let that = this
			this.$router.push({
				path: "/djxxDetail",
				query: {
					id: id,
					title: that.seclectTitle,
					one_id: that.seclectTitleId,
					flag: 1
				}
			})
		},
		getDataList() {
			let that = this

			news.TwoClassList(that.getdata).then((res) => {
				if (res.code == 200) {
					that.dataList = res.data.pagedata
					that.total = res.data.count
				}

			})
		},
		
		getTitleList() {
			let that = this
			news.djxxClass().then((res) => {
				if (res.code == 200) {
					that.titleList = res.data
					that.seclectTitleId = res.data[0].class_id
					that.seclectTitle = res.data[0].title
					that.getdata.one_id = res.data[0].class_id
					// that.swiper()
					that.getDataList()
				}
			})
		}
	},
	mounted() {
		if (this.$route.query.type == 'search') {
			this.getdata.keys = this.$route.query.keys
		}
		this.getTitleList()
		
		// this. swiper()
	},
	created() {
		this.$emit("highLight", 2, "", "", "");
	}
}
</script>

<style lang="scss">
@import '@/common/index.scss';

.index {
	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}

	}

	div {
		box-sizing: border-box;
	}

	.djxxhome_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;
		position: relative;

		/* 搜索框部分 */
		.search {
			position: absolute;
			top: -127px;
			width: 100%;
			height: 107px;
			/* background-color: skyblue; */
			display: flex;
			justify-content: center;

			.search_item {
				height: 77px;
				width: 600px;
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;

				/* background-color: pink; */
				input {
					display: block;
					background-color: #FCEAE4;
					background: rgba(255, 255, 255, 0.8);
					border-radius: 304px;
					height: 40px;
					width: 100%;
					box-sizing: border-box;
					border: 1px solid #FFFFFF;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0.1em;
					padding-left: 20px;
					color: #9E9E9E;
					outline: none;
				}

				.search_item_buttom {
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 1px;
					top: 1px;
					height: 38px;
					width: 120px;
					background-color: #EE632B;
					border-radius: 0px 20px 20px 0px;

					.search_item_buttom_icon {
						margin-right: 12px;
						width: 24px;
						height: 20px;

						img {
							height: 100%;
							width: 100%;
						}
					}

					.search_text {
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #FFFFFF;
						height: 32px;
						line-height: 32px;
					}

				}

				.bottom_keys {
					// width: 100%;
					height: 17px;
					/* background-color: pink; */
					width: 450px;
					display: flex;
					justify-content: space-around;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;

					color: #FFFFFF;
				}
			}
		}

		// 上方筛选标题

		
		.swiper {
			position: relative;
			width: 100%;
			// height: 165px !important;
			margin-left: auto;
			margin-right: auto;
			margin-top: 20px;
			
			overflow: hidden;

			.swiper-wrapper {
				
				.swiper-slide_item {
					cursor: pointer;
					text-align: center;
					font-size: 18px;
					height: 60px !important;
					/* Center slide text vertically */
					display: -webkit-box;
					display: -ms-flexbox;
					display: -webkit-flex;
					display: flex;
					-webkit-box-pack: center;
					-ms-flex-pack: center;
					-webkit-justify-content: center;
					justify-content: center;
					-webkit-box-align: center;
					-ms-flex-align: center;
					-webkit-align-items: center;
					align-items: center;

					box-sizing: border-box;
					overflow: hidden;
					width: 224px;
					border-top: 4px solid #CD050E;
					background-color: #F6F6F6;
					justify-content: center;
					align-items: center;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					line-height: 22px;
					text-align: center;
					letter-spacing: 0px;

					/* color: #000000; */
					.select_title_item_text {
						box-sizing: border-box;
						width: 200px;
						font-family: PingFangSC-Regular;
						font-size: 14px;
						font-weight: normal;
						text-align: center;
						letter-spacing: 0px;
						/* color: #000000; */
						text-overflow: -o-ellipsis-lastline;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;

					}

				}

				.select_title_item_select {
					background-image: url('../../assets/xiangning/djxx/hover_img.png');
					background-size: cover;
					color: #FFFFFF;
				}

				.swiper-slide_item:hover {
					background-image: url('../../assets/xiangning/djxx/hover_img.png');
					background-size: cover;
					color: #FFFFFF;

					.select_title_item_text {
						color: #FFFFFF;
					}
				}

			}
			.swiper_box{
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					gap: 20px;

				}


		}

		/* 视频列表 */
		.dataList {
			width: 100%;
			/* height: 610px; */
			margin-top: 20px;
			display: flex;
			flex-wrap: wrap;
			justify-content: start;
			align-content: start;
			overflow: hidden;

			.dataList_item {
				width: 224px;
				height: 190px;
				margin-bottom: 20px;
				margin-right: 20px;

				.dataList_item_top_img {
					height: 126px;
					width: 224px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.dataList_item_bottom {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					width: 100%;
					height: 64px;
					border: 1px solid #ECEEF4;
					padding: 10px;

					.dataList_item_bottom_top_title {
						width: 100%;
						height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						line-height: 20px;
						color: #000000;
					}

					.dataList_item_bottom_top_title:hover {
						color: #C9010A;
					}

					.dataList_item_bottom_botom {
						height: 16px;
						width: 100%;
						display: flex;

						.dataList_item_bottom_botom_item {
							overflow: hidden;
							height: 100%;
							width: 74px;
							display: flex;
							justify-content: center;

							.dataList_item_bottom_botom_item_icon {
								height: 12px;
								width: 12px;
								margin-right: 2px;
								position: relative;

								img {
									position: absolute;
									top: 2.5px;
									height: 100%;
									width: 100%;
								}
							}

							.dataList_item_bottom_botom_item_content {
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0em;

								color: #999999;
							}
						}

						.dataList_item_bottom_botom_item:nth-child(2) {
							border-left: 1px solid #ECEEF4;
							border-right: 1px solid #ECEEF4;
							;
						}

						.dataList_item_bottom_botom_item:nth-child(1) {
							display: flex;
							justify-content: start;
						}

						.dataList_item_bottom_botom_item:nth-child(3) {
							display: flex;
							justify-content: end;

							.dataList_item_bottom_botom_item_icon {
								height: 10px;
								width: 15px;
							}
						}
					}
				}


			}

			.dataList_item:nth-child(5n) {
				margin-right: 0;

			}
		}



	}
}
</style>
